import { ArrowLeft, Menu } from 'lucide-react';
import { useSetAtom } from 'jotai';
import { isSidebarOpenAtom } from '@/stores/ui';
import { Link, Params, UIMatch, useMatches, useRouteLoaderData } from 'react-router';
import { useMemo } from 'react';

type Title = React.ReactNode | ((data: any) => React.ReactNode) | null;

function getMatchWithValueInHandle(
  matches: UIMatch[],
  key: string
): UIMatch<unknown, unknown> | undefined {
  return matches.find((match) => {
    return (
      'handle' in match && match.handle && typeof match.handle === 'object' && key in match.handle
    );
  });
}

export function Header() {
  const setIsSidebarOpen = useSetAtom(isSidebarOpenAtom);
  const matches = useMatches();

  const backLink = useMemo(() => {
    const match = getMatchWithValueInHandle(matches, 'backLink');
    if (match) {
      return (match.handle as Record<string, unknown>)['backLink'] as
        | ((params: Params<string>) => string)
        | null;
    }
  }, [matches]);

  const titleMatch = useMemo(() => getMatchWithValueInHandle(matches, 'title'), [matches]);
  const routeData = useRouteLoaderData(titleMatch?.id as string);

  const titleContent = useMemo(() => {
    const title = (titleMatch?.handle as Record<string, unknown>)?.title as Title;
    if (typeof title === 'function') {
      return title(routeData);
    }
    return title;
  }, [titleMatch, routeData]);

  return (
    <div className="z-20 flex h-header w-full items-center justify-start gap-4 border-b bg-white px-4 py-2 text-sm shadow-xs">
      <Menu
        className="h-5 w-5 cursor-pointer text-neutral-800 block lg:hidden"
        onClick={() => setIsSidebarOpen((a) => !a)}
      />
      {backLink && (
        <Link viewTransition to={backLink(matches.at(-1)?.params ?? {})} relative="path">
          <ArrowLeft className="h-5 w-5 cursor-pointer text-neutral-800" />
        </Link>
      )}
      <div className="text-lg lg:text-2xl font-semibold text-neutral-800 w-full">
        {titleContent}
      </div>
    </div>
  );
}
